// @flow
import { createAction } from 'redux-actions';
// API
import Recipe from '../api';
// Types
import type { Dispatch } from '../../types';
// Logger
import { logAPIException } from '../../logHelper';

/***********************
 *** FETCH NUTRITIONAL VALUES BY PRODUCT ID***
 ***********************/

export const fetchNutritionValuesByProduct = createAction('FETCH_NUTRITION_VALUES_BY_PRODUCT');
export const fetchNutritionValuesByProductRequest = createAction(
  'FETCH_NUTRITION_VALUES_BY_PRODUCT_REQUEST',
);

export function findNutritionValuesByProduct(id: number) {
  return async (dispatch: Dispatch) => {
    dispatch(fetchNutritionValuesByProductRequest());
    try {
      const recipeResponse = await Recipe.getRecipesByProduct(id);
      dispatch(fetchNutritionValuesByProduct(recipeResponse));
    } catch (err) {
      dispatch(fetchNutritionValuesByProduct(err));
      logAPIException(err);
    }
  };
}
